import { Component } from '@angular/core';
import { InputTextareaModule } from 'primeng/inputtextarea';

@Component({
  selector: 'app-firma-contrato-inquilino',
  standalone: false,
  templateUrl: './firma-contrato-inquilino.component.html',
  styleUrl: './firma-contrato-inquilino.component.scss'
})

export class FirmaContratoInquilinoComponent {

}
